import { FC, useEffect, useState } from "react";
import { useGlobalMessageActions } from "../../../entities/globalMessage";
import { useMyActions } from "../../../entities/my";
import { IDeleteStudentRegularScheduleResponse, scheduleService } from "../../../entities/schedule";
import { AuthError } from "../../../shared/lib/error/AuthError";
import { MyError } from "../../../shared/lib/error/MyError";
import { MyButton } from "../../../shared/ui/button";
import { Modal } from "../../../shared/ui/modal";
import { MyTextarea } from "../../../shared/ui/myTextarea";
import classes from './studentRegularScheduleDelete.module.scss'

interface IProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    studentId: string;
    onSuccess: (response: IDeleteStudentRegularScheduleResponse) => void;
}

export const StudentRegularScheduleDelete: FC<IProps> = ({open, setOpen, studentId, onSuccess}) => {

    const {setIsAuth} = useMyActions()
    const {setGlobalMessage} = useGlobalMessageActions()

    const [comment, setComment] = useState<string>('')
    const [isDeleting, setIsDeleting] = useState<boolean>(false)
    const [error, setError] = useState<string>('')

    useEffect(() => {
        if(!open) return

        setComment('')
        setError('')
    }, [open])

    const onClose = (value: boolean) => {
        if(!value) setError('')
        setOpen(value)
    }

    const deleteSchedule = async () => {
        if(!comment.trim()){
            setError('Укажите причину удаления графика')
            return
        }

        try{
            setIsDeleting(true)
            const response = await scheduleService.deleteStudentRegularSchedule({
                studentId,
                comment: comment.trim(),
            })

            setGlobalMessage({
                message: response.cancelledLessonsCount
                    ? `График удалён. Удалено будущих занятий: ${response.cancelledLessonsCount}`
                    : 'График удалён',
                type: 'ok',
            })
            onClose(false)
            onSuccess(response)
        }
        catch(requestError){
            console.log(requestError)

            if(requestError instanceof AuthError){
                setIsAuth(false)
                setGlobalMessage({message: requestError.message, type: 'error'})
            }
            else if(requestError instanceof MyError){
                setGlobalMessage({message: requestError.message, type: 'error'})
            }
            else{
                setGlobalMessage({message: 'Ошибка при удалении регулярного графика', type: 'error'})
            }
        }
        finally{
            setIsDeleting(false)
        }
    }

    return (
        <Modal open={open} setOpen={onClose}>
            <section className={classes.modal}>
                <section className={classes.header}>
                    <section>
                        <h3>Удалить регулярный график?</h3>
                        <p>Сам график будет закрыт. Будущие запланированные занятия этого графика удалятся автоматически.</p>
                    </section>
                    <button type="button" className={classes.closeButton} onClick={() => onClose(false)}>×</button>
                </section>

                <section className={classes.content}>
                    <MyTextarea
                        title="Причина удаления"
                        value={comment}
                        setValue={setComment}
                        error={error}
                        setError={setError}
                        disabled={isDeleting}
                    />
                </section>

                <section className={classes.actions}>
                    <button type="button" className={classes.cancelButton} onClick={() => onClose(false)} disabled={isDeleting}>Оставить график</button>
                    <section className={classes.deleteButton}>
                        <MyButton isLoading={isDeleting} onClick={deleteSchedule}>Удалить график</MyButton>
                    </section>
                </section>
            </section>
        </Modal>
    )
}
